module.exports = __webpack_public_path__ + "static/media/Piercing-femintimate-Labiamenora.a2c03c41.png";